import React from 'react';
import { Calculator, PiggyBank, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function BudgetSimulatorPromo() {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200/50 dark:border-gray-700/50 overflow-hidden">
      <div className="relative overflow-hidden">
        {/* Background gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 to-accent-50/80 dark:from-primary-900/30 dark:to-accent-900/30" />
        
        <div className="relative p-4">
          <div className="flex items-center gap-3 mb-3">
            <div className="p-2 bg-white dark:bg-gray-800 rounded-lg">
              <Calculator className="w-5 h-5 text-primary-500 dark:text-primary-400" />
            </div>
            <div>
              <h4 className="text-base font-medium text-gray-900 dark:text-white">
                Simulateur de budget PVT
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Planifiez votre budget avec précision
              </p>
            </div>
          </div>

          <div className="p-3 bg-white/70 dark:bg-gray-800/50 rounded-lg mb-4 border border-gray-200/50 dark:border-gray-700/50">
            <div className="flex items-center gap-2">
              <PiggyBank className="w-5 h-5 text-accent-500 flex-shrink-0" />
              <p className="text-sm text-gray-700 dark:text-gray-300">
                Calculez vos dépenses mensuelles, coûts d'installation et économies requises en fonction de votre destination.
              </p>
            </div>
          </div>

          <Link
            to="/simulateur-budget"
            className="block w-full text-center px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-lg transition-colors text-sm font-medium flex items-center justify-center gap-2"
          >
            <span>Commencer la simulation</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}